export default {
	"cityPlan": {
		"autoRouteAdd": "automatically add",
		"downExcleRouterList": "export the waybill",
		"revokeOrder": "withdraw",
		"importExcleLine": "import route",
		"planInMap": "adjust on map",
		"lineMeasure": "line measurement",
		"importTips3": "import direct dispatching thread scheduling information",
		"info": "information",
		"autoLineResultTitle": "automatic route planning results",
		"sucRoute": "succeed waybill",
		"errRoute": "failed waybill",
		"onTimeRoute": "on time",
		"totalKm": "total mileage",
		"generalCargo": "total volume",
		"sectionsRoute": "route split",
		"splitGoods": "quantity split",
		"revokeSections": "withdraw route split",
		"revokeSplit": "withdraw quantity split",
		"modifyTime": "modified time",
		"detailSplit": "detail split",
		"transitInformation": "transit information",
		"transportSplit": "waybill split",
		"oldTransportWeight": "original weight (kg)",
		"splitWeight": "splitted weight (kg)",
		"oldTransportVolume": "original volume (cubic meter)",
		"splitVolume": "splitted volume (cubic meter)",
		"originalDeclaredPrice": "original declared price",
		"splitOriginalDeclaredPrice": "splitted declared price",
		"receiptQty": "the original number of pods",
		"splitReceiptQty": "splitted number of pods",
		"packingQty": "number of original packages",
		"splitPackingQty": "splitted original packages",
		"goodsQty": "original quantity",
		"splitGoodsQty": "splitted item quantity",
		"splitted": "Splitted",
		"split": "Split",
		"Tips1": "when filling in the weight, other dismantling quantities will be automatically generated proportionally",
		"Tips2": "weight of split order should be greater than 0 or less than the original weight",
		"Tips3": "volume of split order should be greater than 0 or less than the original volume",
		"Tips4": "declare value of split order should be greater than/equal 0 or less/equal the original declare value",
		"Tips5": "order can not be split when the package quantity is 1",
		"Tips6": "order can not be split when the item quantity is 1",
		"Tips7": "Value must not exceed the original number",
		"IncorrectWeight":"Incorrect Total Weight kg Split format",
		"IncorrectVolume":"Incorrect Total Volume cubic meter Split format",
		"IncorrectDeclared":"Incorrect Declared Value Split format",
		"IncorrectNumberOfReceipts":"Incorrect Number of Receipts Split format",
		"IncorrectTotalItems":"Incorrect Total items Split format",
		"IncorrectTotalNumberOfPackages":"Incorrect Total Number of Packages Split format"
	},
	"planlookCity": {
		"planlookcityTransitTitle": "Waybill transit station settings",
		"planlookcitySplitDetailTitle": "Document Split Details"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/cityPlan/cityPlan.js